/* ==========================================================================
   LSC - Collage Collection: filter memory (created 15 Oct 2026, v5;
   v11 16 Oct 2026: restoring moved to the early redirect, see RESTORE;
   v12 16 Oct 2026: closes the saved-filters notice; v17 18 Oct 2026: and
   the saved-filters-applied notice)
   assets/lsc-collage-collection-filters.js

   Loaded by sections/lsc-collage-collection.liquid only when "Enable
   filtering" and "Remember filters" are both on, and always AFTER the
   theme's assets/collection.js and assets/lsc-collage-collection-cookie.js
   (deferred scripts run in document order; this file calls methods on the
   cookie helper).

   WHAT IT DOES
   Keeps the shopper's filters and sort order in one first-party cookie,
   lsc_filters, holding the query string of the filter params, e.g.
     filter.p.m.custom.concern=Acne&filter.p.vendor=GlyMed&sort_by=price-ascending
   Only "filter.*" and "sort_by" params are kept; paging, preview and view
   params never are.
   LSC - v8: the same cookie also carries the chosen Collage / List view
   (lsc_view=list, saved by assets/lsc-collage-collection-view.js). This
   file never touches that entry: it reads and writes through the helper's
   getFilters() / setFilters(), which keep the view as it is.

   SAVE
   The theme's filter script (form[is="facet-form"], data-history) writes
   every filter / sort change into the page URL with history.replaceState,
   re-renders the section, then fires "collection:reloaded". On that event
   the filter params are read from the URL and saved. No filter params left
   (the shopper cleared them all) = the saved filters are cleared (v8: the
   cookie itself stays if it holds a view).
   A page that OPENS with filter params in its URL (a shared link, a
   refresh) also saves them: the URL is the most recent choice.
   sort_by is left out when it's just this collection's default order
   (data-default-sort on the section): the theme's form submits the sort
   menu with every filter change, so without this the default order of one
   collection would be forced onto every other collection.

   RESTORE (LSC - v11, 16 Oct 2026, audit fix 7: moved out of this file)
   Saved filters are now re-applied by the inline early script
   (snippets/lsc-collage-collection-early.liquid), which redirects to the
   filtered URL before the page is drawn. v5-v10 did it here: the page
   loaded unfiltered with its rows hidden, then this script fetched the
   filtered section and swapped it in (two renders, wasted photo downloads,
   rows hidden for up to 4 seconds). What is left here:
     - the filtered page a redirect lands on is recognised by the
       sessionStorage note "lsc_restored" (the query the early script
       applied). That page is NOT saved over the cookie, so saved filters
       that don't apply to this collection are still kept for others; the
       cookie is only re-written as it was, to refresh its expiry;
     - .lsc-cc--restoring is removed in case it is still set (the early
       script sets it just before leaving the page).

   SAVED-FILTERS NOTICE (LSC - v12, 16 Oct 2026)
   The early script adds .lsc-cc--saved-na to the section root when none of
   the shopper's saved filters fit this collection, and the CSS shows a
   small pill above the floating buttons that fades out on its own. This
   script only hides it early: when its close button is pressed, and when
   the shopper changes the filters (the notice is out of date then).

   HIDING THE UNFILTERED ROWS
   Only for the instant before the redirect (see above). The CSS shows the
   rows after 4 seconds on its own, in case this script never runs.

   EXPIRY AND CONSENT
   Handled by the shared helper, assets/lsc-collage-collection-cookie.js
   (v6; loaded before this file): expiry in the year 9999, consent check,
   path / SameSite / Secure. The cookie is re-written on every page view
   that loads this script, because browsers cap cookie lifetimes (Chrome,
   Edge, Firefox: 400 days; Safari: 7 days for script-set cookies).

   VIEWS (v6)
   Both the collage and the list view sit inside #ProductGridContainer;
   nothing view-specific happens here.

   THEME EDITOR
   No restore inside the theme editor (the early script never redirects
   there), so merchants always see the collection as configured. Re-scans
   on shopify:section:load.
   ========================================================================== */
(function () {
  // A second section instance loaded the file again: just pick it up.
  if (window.LscCcFilters) {
    window.LscCcFilters.scan();
    return;
  }

  // v6: cookie handling lives in the shared helper. Without it (it failed
  // to load) there is nothing to save to or restore from.
  var Cookie = window.LscCcCookie;
  if (!Cookie) {
    document.querySelectorAll('[data-lsc-cc-remember]').forEach(function (root) {
      root.classList.remove('lsc-cc--restoring');
    });
    return;
  }

  /** Filter or sort param? (Paging, view, preview params are not.) */
  function isFilterKey(key) {
    return key.indexOf('filter.') === 0 || key === 'sort_by';
  }

  /** Only the non-empty filter/sort params from a query string. */
  function pick(search) {
    var out = new URLSearchParams();
    new URLSearchParams(search).forEach(function (value, key) {
      if (isFilterKey(key) && value !== '') out.append(key, value);
    });
    return out;
  }

  /** Drop sort_by when it is only the collection's default order (see SAVE). */
  function withoutDefaultSort(params, root) {
    var defaultSort = root && root.getAttribute('data-default-sort');
    if (defaultSort && params.get('sort_by') === defaultSort) params.delete('sort_by');
    return params;
  }

  /** The saved filter query string, or ''. LSC - v8: the cookie also holds
      the chosen view (lsc_view); the helper leaves it out here. */
  function readCookie() {
    return Cookie.getFilters();
  }

  /** Save a filter query string ('' clears the filters). LSC - v8: the
      helper keeps the saved view, so clearing filters never forgets it. */
  function writeCookie(query) {
    Cookie.setFilters(query);
  }

  /** Show the rows again (see HIDING THE UNFILTERED ROWS). */
  function reveal(root) {
    root.classList.remove('lsc-cc--restoring');
  }

  /** v11: the query the early script redirected with, or '' (and the note
      is cleared, so it only ever counts once). */
  function takeRestored() {
    try {
      var query = window.sessionStorage.getItem('lsc_restored') || '';
      window.sessionStorage.removeItem('lsc_restored');
      return query;
    } catch (e) {
      return ''; // storage unavailable: treat the page as a normal visit
    }
  }

  /** v12: hide the saved-filters notice (see SAVED-FILTERS NOTICE).
      LSC - v17 (18 Oct 2026): the same pill also carries the "we applied N
      saved filters" message (.lsc-cc--saved-on, set by the early script);
      closing it or changing the filters hides that one too. */
  function hideNote(root) {
    root.classList.remove('lsc-cc--saved-na', 'lsc-cc--saved-on');
  }

  /** Per section: save the URL's filters (or, after a restore redirect,
      keep the saved set), refresh the cookie's expiry, show the rows. */
  function setup(root) {
    if (root.__lscCcFilters) return; // already handled
    root.__lscCcFilters = true;
    reveal(root);

    // v12: the notice's close button (inside the floating bar, which sits
    // inside the root, so one delegated listener covers it).
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-lsc-cc-note-close]')) hideNote(root);
    });

    var restored = takeRestored();
    var current = withoutDefaultSort(pick(location.search), root).toString();
    var saved = readCookie();

    // v11: the page the early script's redirect opened. Its URL holds only
    // the saved filters that apply here; keep the full saved set instead.
    if (current && restored && current === withoutDefaultSort(pick(restored), root).toString()) {
      if (saved) writeCookie(saved); // refresh the expiry (see EXPIRY)
      return;
    }

    if (current) {
      writeCookie(current); // the URL is the latest choice
      return;
    }
    if (saved) writeCookie(saved); // refresh the expiry (see EXPIRY)
  }

  /** Set up every section on the page that has filter memory on. */
  function scan() {
    document.querySelectorAll('[data-lsc-cc-remember]').forEach(setup);
  }

  // SAVE: after every filter / sort change made by the shopper.
  document.addEventListener('collection:reloaded', function () {
    var root = document.querySelector('[data-lsc-cc-remember]');
    if (!root) return;
    hideNote(root); // v12: the shopper changed the filters, the notice is stale
    writeCookie(withoutDefaultSort(pick(location.search), root).toString());
  });

  document.addEventListener('shopify:section:load', scan);

  window.LscCcFilters = { scan: scan };
  scan();
})();
